export const convert_gpm_to_magY = v => Math.max(Math.round((v*23.3) + 530), 0)
export const convert_magY_to_gpm = v => Math.max(Math.round((v-530)/23.3), 0)


export const alert_form_config = {
    typeOptions: [
        { value: null, text: 'Please select an option' },
        { value: 'LEAK', text: 'Leak Alert'},
        { value: 'WATER_NUMBER', text: 'WaterNumber' },
        { value: 'HIGHFLOW', text: 'High Flow Alert' },
        { value: 'LOWFLOW', text: 'Low Flow Alert' },
    ],

    criticalityTypeOptions: [
        { value: null, text: 'Please select an option' },
        { value: 'INFO', text: 'Info' },
        { value: 'WARN', text: 'Warn' },
        { value: 'EMERGENCY', text: 'Emergency' }
    ],

    enableTypeOptions: [
        { value: '0', text: 'No' },
        { value: '1', text: 'Yes' },
    ]
}


export const from_string_to_array = str => str.substring(1, str.length - 1).split(',')
export const map_units = unit => (({
    gpm: '(GPM)',
    PSI: '(psi)',
    '':'', 
})[unit] || `(${unit})`)


export const map_alerts_to_units = ({ alertType, threshold }) => ({
    'LEAK': `${threshold} hrs`,
    'BATTERY': `${threshold} mV`,
    'HIGHFLOW': `${threshold} Flow Rate`,
    'LOWFLOW': `${threshold} GPM`,
    'LOWPRESSURE': `${threshold} psi`,
    'LOWLEVEL': `${threshold} in`,
    'HIGHLEVEL': `${threshold} in`,
    'DEVICE_BATTERY': `${threshold} mV`,
    'WATER_NUMBER': `${threshold}%`,
    'COMMUNICATION': `8 hrs`
})[alertType]
